const xToDot = str => str.replace(/x/gi, '•')

const defaultCardMask = str =>
  str.replace(
    /^(x{4})(x{4})(x{4})(\d{4})$/i,
    (m, p1, p2, p3, p4) => `${xToDot(p1)} ${xToDot(p2)} ${xToDot(p3)} ${p4}`,
  )

const genericCardMask = (str) => {
  // Input validation
  if (!str || typeof str !== 'string') {
    return str;
  }

  const cardLength = str.length;

  // Handle different card lengths using switch case
  switch (cardLength) {
    case 14:
      // 14-digit cards: •••• •••••• 1234
      return str.replace(
        /^(x{4})(x{6})(\d{4})$/i,
        (m, p1, p2, p3) => `${xToDot(p1)} ${xToDot(p2)} ${p3}`
      );

    case 15:
      // 15-digit cards: •••• •••••• •1234
      return str.replace(
        /^(x{4})(x{6})x(\d{4})$/i,
        (m, p1, p2, p3) => `${xToDot(p1)} ${xToDot(p2)} •${p3}`
      );

    case 16:
      // 16-digit cards: •••• •••• •••• 1234
      return str.replace(
        /^(x{4})(x{4})(x{4})(\d{4})$/i,
        (m, p1, p2, p3, p4) => `${xToDot(p1)} ${xToDot(p2)} ${xToDot(p3)} ${p4}`
      );

    case 19:
      // 19-digit cards: •••• •••• •••• •••1 234
      return str.replace(
        /^(x{4})(x{4})(x{4})(x{3})(\d{1})(\d{3})$/i,
        (m, p1, p2, p3, p4, p5, p6) => `${xToDot(p1)} ${xToDot(p2)} ${xToDot(p3)} ${xToDot(p4)}${p5} ${p6}`
      );

    default:
      // For unsupported lengths, return the original string
      return str;
  }
}
const defaultAccountMask = str =>
  str.replace(/^(x+)(\d{4})$/i, (m, p1, p2) => `${xToDot(p1)} ${p2}`)

const displayMasks = {
  4: defaultAccountMask,
  5: defaultCardMask,
  6: defaultCardMask,
  7: genericCardMask,
  8: str =>
    str.replace(
      /^(x{4})(x{6})x(\d{4})$/i,
      (m, p1, p2, p3) => `${xToDot(p1)} ${xToDot(p2)} •${p3}`,
    ),
  13: defaultAccountMask,
  14: defaultAccountMask,
  20: defaultCardMask,
  22: defaultAccountMask,
}

export default id => displayMasks[id]
